import React, { Component } from 'react';
import ReportHeader from '../../ReportHeader'
import ReportHeader2 from '../../ReportHeader2'
import ReportHeader3 from '../../ReportHeader3'
import Section from '../../ReportSection/index'
import SpecTable from 'components/display/SpecTable'
import { PEX_DATAPOINT_EXCEED_ERROR } from './constants'
import ErrorTable from '../ErrorTable'
import T from 'i18n-react'
import styles from './styles.scss'
import CSSModules from 'helpers/CSSModulesUtil'
import SuccessStatus from '../../SuccessStatus/index'
import { connect } from 'react-redux'
import { downloadFiles } from 'containers/Project/NvqualSection/actions'
import { compose } from 'recompose';

const mapDispatchToProps = (dispatch) => {
  return {
      onDownloadFile: (files, name) => dispatch(downloadFiles(files, name))
  }
}


class NvlinkQualTest extends Component {


    renderAdditionalErrorInformation (errorType, info) {
        if (errorType == 'nvlink_qual_test_datapoint_greater_than_0') {
            return (
                PEX_DATAPOINT_EXCEED_ERROR.map(x => {
                    return (
                        <code>{`${T.translate(`containers.project.nvqualSection.errors.nvlinkQualGreaterThanZero.${x}`)}: ${info[x]}`}<br/></code>
                        )
                })
            )
        }
    }

    render(){
        const { error, onDownloadFile, files, testName, testId, result } = this.props
        const hasErrorData = error && error.length > 0

        return(
        <Section>
            <ReportHeader 
                  title={T.translate(`containers.project.nvqualSection.test.${testId}`)}
                  showDownload
                  onDownloadClick={onDownloadFile.bind(this, files.map((f) => f.id), testName)}/>
            <Section>
                <ReportHeader2 title={'Summary'} />
                <Section>
                <SuccessStatus result={result} />
                {hasErrorData && 
                <React.Fragment>
                <ReportHeader3 title={'Errors'} />
                    <ErrorTable
                        errors={error}
                        errorSpecificRenderFunc={this.renderAdditionalErrorInformation} />
                </React.Fragment>}
                </Section>
            </Section>
        </Section>
        );
    }
    }

    const withConnect = connect(null, mapDispatchToProps)
    const withStyles = CSSModules(styles);
    const enhance = compose(withConnect, withStyles);
    export default enhance(NvlinkQualTest);
